
<template>
  <div></div>
</template>

<style scoped>

</style>
<script>
import {getImei, readCommonParam} from "@/util/session-storage-utils";
import {navigateToAudio, navigateToIndex} from "@/util/jsinterfaces-util";
export default {
  name: "AudioIndex",
  created(){

    // document.title = this.$t("");
  },
  mounted(){
    document.addEventListener('visibilitychange', this.getHiddenStatus, true);
    readCommonParam(this)
    try {
      navigateToAudio(getImei())
    }catch (e){
      navigateToAudio(getImei())
    }


  },
  data(){
    return {
      hidden:false
    }
  },
  methods:{
    getHiddenStatus() {
      const isHidden = document.hidden;
      if (isHidden) {
        this.hidden = true
      } else {
        if(this.hidden){
          navigateToIndex(getImei())
        }
      }
    }
  }
}
</script>
